export default __webpack_public_path__ + "0162db05b51421fdb6212d6b87ad1bd2.svg";